import Base from '../../components/base';

const templatePlotlineLegendItem = line => `
	<li class="stack__item">
		<button class="button button--icon js-plotline-remove" data-id="${line.id}">
			<span class="button__icon">
				<svg viewBox="0 0 16 16" class="icon icon--s">
					<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/icons/sprite.svg#close"></use>
				</svg>
			</span>
			${line.id}
		</button>
	</li>
`;

class Plotlines extends Base {
	constructor(el, chart, yAxisId) {
		super(el);

		this.el = el;
		this.chart = chart;
		this.yAxisId = yAxisId;
	}

	get yAxis() {
		return this.chart.get(this.yAxisId);
	}

	get addedPlotlines() {
		return this.yAxis.plotLinesAndBands || [];
	}

	add(id, value, text) {
		// don't add doubles
		if (this.exists(id)) {
			return;
		}

		this.yAxis.addPlotLine({
			id,
			value,
			label: {
				text,
				x: 0,
				y: -5, // magic number, depends on padding of label in CSS
				useHTML: true,
			},
		});

		this.updateUI();

		this.eventbus.emit('chart:plotline:toggled', { id, action: 'added' });
	}

	remove(id) {
		if (!this.exists(id)) {
			return;
		}

		this.yAxis.removePlotLine(id);

		this.updateUI(this.addedPlotlines);

		this.eventbus.emit('chart:plotline:toggled', { id, action: 'removed' });
	}

	updateUI() {
		this.rescaleAxis();
		this.updateLegend(this.refs.plotlinesLegend);
	}

	exists(id) {
		return this.addedPlotlines.some(pl => pl.id === id);
	}

	// y-axis isn't scaled when plotline is added, resulting in a plotline out of view
	// scale the y-axis manually
	rescaleAxis() {
		const plotlineValues = this.addedPlotlines.map(line => line.options.value);
		const { dataMin, dataMax } = this.yAxis;

		// get lowest and highest value, either from data or from plotlines
		const minValue = plotlineValues.length ? Math.min(...[dataMin, ...plotlineValues]) : null;
		const maxValue = plotlineValues.length ? Math.max(...[dataMax, ...plotlineValues]) : null;

		// when min / max is `null`, Highcharts scales automatically
		this.yAxis.update({ min: minValue, max: maxValue });
	}

	updateLegend(legendElement) {
		const legendHTML = this.addedPlotlines.reduce((tpl, line) => `
				${tpl}
				${templatePlotlineLegendItem(line)}
			`, '');

		Plotlines.renderLegend(legendElement, legendHTML);
	}

	static renderLegend(legendElement, HTML) {
		legendElement.innerHTML = HTML;
	}
}

export default Plotlines;
